import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const PrudentialLayout = () => {
  return (
    <div className="app-wrapper">
      <nav className="pub-nav">
        <Link to="/login" className="pub-brand">Prudential Auditing</Link>
        <Link to="/login" className="pub-link">Login</Link>
      </nav>
      <main className="pub-main">
        <Outlet />
      </main>
    </div>
  );
};

export default PrudentialLayout;
